module.exports = __webpack_public_path__ + "static/media/share-white.f84b8689.svg";